var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section__lk-order-status"},[_c('div',{class:'status status_' + _vm.status})])
}
var staticRenderFns = []

export { render, staticRenderFns }